<ng-container *ngIf="showSpinner;">
  <div class="featured-loader container" style="min-height:50vh" fxLayout="row" fxLayoutAlign="center center">
    <uni-loader></uni-loader>
  </div>
</ng-container>
